import axios, { CancelTokenSource } from 'axios';
export const getBusinessLogicConfiguration = (
  obj: any,
  tokenSource?: CancelTokenSource
) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/business-logic`,
    {
      params: obj,
    }
  );
};
export const getBusinessLogicConfigurationSqlValidate = (
  obj: Object,
  tokenSource?: CancelTokenSource
) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/business-logic/sql-validation`,
    obj,
    { headers, cancelToken: tokenSource?.token }
  );
};
export const AddBusinessLogicConfiguration = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/business-logic/add`,
    obj,
    { headers }
  );
};

export const EditBusinessLogicConfiguration = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/business-logic/update`,
    obj,
    { headers }
  );
};

export const DeleteBusinessLogicConfiguration = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/business-logic/delete`,
    obj,
    { headers }
  );
};